import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';

// Proteção adicional para evitar exposição de credenciais no frontend
if (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'development') {
  // Desabilitar console.log em produção
  if (process.env.NODE_ENV === 'production') {
    console.log = () => {};
    console.info = () => {};
    console.debug = () => {};
  }

  // Sobrescrever console.error e console.warn para remover informações sensíveis
  const originalError = console.error;
  console.error = (...args) => {
    const sanitizedArgs = args.map(arg => {
      if (typeof arg === 'string') {
        // Remover chaves de API, tokens e outras informações sensíveis
        return arg
          .replace(/([A-Za-z0-9_-]{35,40})/g, '[REDACTED]') // Chaves de API Firebase
          .replace(/(firebase.*key.*=.*|key.*=.*)/gi, (match) => match.replace(/=.*/, '=[REDACTED]')) // Parâmetros de chave
          .replace(/(password.*=.*|token.*=.*)/gi, (match) => match.replace(/=.*/, '=[REDACTED]')); // Senhas e tokens
      }
      return arg;
    });
    originalError.apply(console, sanitizedArgs);
  };

  const originalWarn = console.warn;
  console.warn = (...args) => {
    const sanitizedArgs = args.map(arg => {
      if (typeof arg === 'string') {
        // Remover chaves de API, tokens e outras informações sensíveis
        return arg
          .replace(/([A-Za-z0-9_-]{35,40})/g, '[REDACTED]') // Chaves de API Firebase
          .replace(/(firebase.*key.*=.*|key.*=.*)/gi, (match) => match.replace(/=.*/, '=[REDACTED]')) // Parâmetros de chave
          .replace(/(password.*=.*|token.*=.*)/gi, (match) => match.replace(/=.*/, '=[REDACTED]')); // Senhas e tokens
      }
      return arg;
    });
    originalWarn.apply(console, sanitizedArgs);
  };

  // Bloquear acesso direto às variáveis de ambiente no console do navegador
  if (typeof window !== 'undefined') {
    Object.defineProperty(window, 'process', {
      enumerable: true,
      get: function() {
        return { env: {} };
      }
    });
  }
}

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);